import React, {useState, useEffect} from 'react';
import person from "../../assets/images/person.jpg";
import styles from "../../assets/stylesheets/sass/AdminDashboard.module.scss";
export default function Translations(){

	return (
	    <>
        <div className={styles.content}>
            <div className={styles.person_container}>
                <div className={styles.person_information}>
                    <div className={styles.profile_picture}><img src={person} alt="person"/></div>
                    <div className={styles.person_information_text}>
                        <p className={styles.person_name}>Veerle Yzewyn</p>
                        <p className={styles.person_profession}>Professioneel strontverzamelaar</p>
                    </div>
                </div>
                <div className={styles.statistics_content}>
                    <div className={styles.person_box}>
                        <p className={styles.statistic_title}>Aantal bestellingen verwerkt</p>
                        <p className={styles.statistic_text}>2.837 bestellingen</p>
                    </div>
                    <div className={styles.person_box}>
                        <p className={styles.statistic_title}>Laatst ingelogd</p>
                        <p className={styles.statistic_text}>Gisteren</p>
                    </div>
                </div>
            </div>
            <div>
                <p>Dashboard</p>
            </div>
        </div>
	    </>  
  	);
}